import React from 'react';
import { List } from 'immutable';
import _ from 'lodash';
import PaymentRadio from '../../../payment/PaymentRadio';
import { translate as t } from '../../../../lib/I18n';
import classnames from 'classnames';
import { Grid, Row } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import CustomerPostalAddress from '../../../customer/PostalAddress';
import Button from 'react-bootstrap/lib/Button';
import OnEnterTrigger from '../../../general/OnEnterTrigger';

const SelectAddress = ({
    addresses,
    addressForm,
    setAddressForm,
    addNewAddress,
    setAddNewAddress,
    selectedAddress,
    setSelectedAddress,
    onChange,
}) => {
    return (
        <Grid>
            <h2 className="auto-dr__header">{t('auto-dr.subscribe.modal-address-title')}</h2>
            <p>{t('auto-dr.subscribe.modal-address-subtitle')}</p>
            <ul className="auto-dr__address-wrapper margin-top--md margin-bottom--sm">
                {addresses.map(({ id, line1, line2, line3, town, postCode, country }) => {
                    const isSelected = selectedAddress === id;

                    const addressParts = [line1, line2, line3, town, postCode, country].filter(_.identity).join(', ');

                    const ariaText = `${isSelected ? t('auto-dr.subscribe.modal-address-item.selected') : t('auto-dr.subscribe.modal-address-item.select')}: ${addressParts}`;

                    return (
                        <li
                            className="auto-dr__address-item "
                            key={id}
                        >
                            <OnEnterTrigger
                                className={classnames('address__selector', {
                                    'address__selector--selected': selectedAddress === id
                                })}
                                onClick={() => setSelectedAddress(id)}
                                srOnly={ariaText}
                            >
                                <PaymentRadio
                                    className="address__selector__radio-icon small"
                                    isSelected={isSelected}
                                />
                                <address className="auto-dr__address-item__label text-left">
                                    {line1 ? <p>{line1}</p> : null}
                                    {line2 ? <p>{line2}</p> : null}
                                    {line3 ? <p>{line3}</p> : null}
                                    {town ? <p>{town}</p> : null}
                                    {postCode ? <p>{postCode}</p> : null}
                                    {country}
                                </address>
                            </OnEnterTrigger>
                        </li>
                    );
                })}
            </ul>
             <Button
                bsStyle='primary'
                className="js-continue"
                onClick={ () => setAddNewAddress(true) }
            >
                {t('auto-dr.subscribe.modal-address.add-new-address')}
            </Button>

            {addNewAddress && <Row>
                <CustomerPostalAddress form={addressForm} onChange={onChange} onSelectAddress={(address) => {
                    setAddressForm(addressForm.merge({
                        addressLine1: address.get('line1') || '',
                        addressLine2: address.get('line2') || '',
                        addressLine3: address.get('line3') || '',
                        townCity: address.get('town') || '',
                        postcode: address.get('postCode') || ''
                    }));
                    setSelectedAddress(address);
                }} />
            </Row>}
        </Grid>
    );
};

SelectAddress.propTypes = {
    form: PropTypes.object,
    addressForm: PropTypes.func,
    setAddressForm: PropTypes.func,
    addNewAddress: PropTypes.bool,
    setAddNewAddress: PropTypes.func,
    selectedAddress: PropTypes.object,
    setSelectedAddress: PropTypes.func,
    onChange: PropTypes.func,
    addresses: PropTypes.instanceOf(List),
};

export default SelectAddress;



// WEBPACK FOOTER //
// ./src/components/account/subscribeDelayRepay/components/SelectAddress.js